import { WebP } from '/src/components/WebP';
import { Button } from '@crazyegginc/hatch';
import classNames from 'classnames';

import { useMetric, usePermissions, useAuthContext } from '/src/hooks';
import { Modal } from '/src/contexts/modal';

import { FEATURES } from '/src/features/_global/constants';

import UpsellBrandingPNG from '@crazyegginc/hatch/dist/images/illustration-upsell-remove-branding-landscape.png';
import UpsellBrandingWebP from '@crazyegginc/hatch/dist/images/illustration-upsell-remove-branding-landscape.webp';

import { ReactComponent as UpsellIcon } from '@crazyegginc/hatch/dist/images/icon-crown-filled.svg';
import { AppLink } from '/src/features/_global/components/AppLink';

export function UpsellModal({ link, metricType }) {
  const trackMetric = useMetric();
  const { currentAccount, isSharing } = useAuthContext();
  const isStripeUser = Boolean(currentAccount?.useStripe);

  const permissions = usePermissions();
  const canManageBilling = permissions.can('edit', FEATURES.BILLING).allowed;

  return (
    <Modal dialogClassName="!w-[640px] !p-0 overflow-hidden">
      <div className="relative w-full -z-[1]">
        <div className="w-full">
          <WebP
            webp={UpsellBrandingWebP}
            fallback={UpsellBrandingPNG}
            width="320"
            height="488"
            alt={'remove branding'}
            imageClassName="w-full"
          />
        </div>
        <div className="w-full border-t border-t-mystic-500 p-[30px]">
          <h4 className="flex items-center text-xl font-semibold text-black-pearl-500 mb-2">
            <UpsellIcon
              className="text-[#fbbd33] mr-3 h-5 w-5 fill-current icon-upsell mb-0.5"
              aria-label={`upsell surveys branding`}
            />{' '}
            {canManageBilling ? 'Upgrade to remove Crazy Egg branding' : 'Request an upgrade to the Starter plan'}
          </h4>
          <p
            className={classNames('text-sm text-black-pearl-500 leading-tight', {
              'mb-0': isSharing,
              'mb-6': !isSharing,
            })}
          >
            {canManageBilling ? (
              'Put your brand in the spotlight by hiding all Crazy Egg branding.'
            ) : (
              <>
                Put your brand in the spotlight by removing Crazy Egg branding. To upgrade and apply the change to your
                Surveys, contact your Account Admin{' '}
                {!isSharing && (
                  <>
                    at <span className="font-bold">{currentAccount?.ownerEmail}</span>
                  </>
                )}
                .
              </>
            )}
          </p>
          {!canManageBilling ? (
            !isSharing ? (
              <Button className="h-[36px] w-[182px]" component="a" href={`mailto:${currentAccount.ownerEmail}`}>
                Contact Account Owner
              </Button>
            ) : null
          ) : (
            <Button
              className="self-start h-[36px] w-[119px]"
              component={AppLink}
              to={link}
              onMouseDown={() => trackMetric('upgrade_cta_click', metricType)}
              target={isStripeUser ? '_blank' : '_self'}
              rel={isStripeUser ? 'noopener noreferrer' : undefined}
            >
              Upgrade Now
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
}
